import { jsonFetch } from "./json_fetch"

const debug = (error, details) => {
  const body = { error, error_details: JSON.stringify(details) }
  jsonFetch("/debug", { method: "POST", body })
}

export { debug }
